import classnames from 'classnames/bind'

import Image, { ImageProps } from '~/components/UI/Image'

import { useProductZoomContext } from '~/providers/ProductZoomProvider'

import useTrackingPromotionImpression from '~/hooks/useTrackingPromotionImpression'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ProductHeaderEditoImageProps {
  className?: string
  image?: ImageProps
}

const IMAGE_SIZES = [{ breakpoint: 'md', ratio: 16 / 24 }, { ratio: 22 / 24 }]

function ProductHeaderEditoImage({
  className,
  image,
}: ProductHeaderEditoImageProps) {
  const { ref } = useTrackingPromotionImpression()

  const { openZoom, images, setImageIndex } = useProductZoomContext()

  if (!image) {
    return null
  }

  // Finding the current imge index amongst images
  const currentImageIndex = images?.findIndex((currentImage) => {
    return currentImage.src === image.src
  })

  return (
    <div ref={ref} className={cx(css.ProductHeaderEditoImage, className)}>
      {image && (
        <Image
          className={css.image}
          layout="fill"
          objectFit="cover"
          ratio={css.ratio}
          sizesFromBreakpoints={IMAGE_SIZES}
          asPlaceholder
          onClick={() => {
            setImageIndex(currentImageIndex)
            openZoom?.()
          }}
          {...image}
        />
      )}
    </div>
  )
}

ProductHeaderEditoImage.defaultProps = {}

export default ProductHeaderEditoImage
